<template>
  <div class="distribution">
    <el-row>
      <el-col :span="isHearderMenu?5:12" class="al">
        <div style="float:left;padding-top: 3px;">
          <el-image style="width: 40px; height: 40px;" :src="Config.logo" fit="contain"></el-image>
        </div>
        <div class="title">{{Config.title}}</div>
      </el-col>
      <el-col v-if="isHearderMenu" :span="13">
        <div class="sysTabbar">
          <div class="sysTabbarList">
            <div class="sysTabbarItem" v-for="(item,index) in TemplateMenuShow.slice(0,maxCount)" :key="index" v-ripple
              @click="menuClick(item)">
              <div class="iconCircle">
                <el-tooltip :content="item.NAME" placement="bottom" effect="light">
                  <i class="iconfont" :class="item.ICON" :style="{'font-size': item.NAME=='工作轨迹'?'22px':'20px'}"></i>
                </el-tooltip>
              </div>
              <div :class="{ angle: menuId==item.ID}"></div>
            </div>
            <el-popover @show="downListState=true" @hide="downListState=false" placement="bottom" class="popover" title="菜单展示设置（双击切换）最多显示七个"
              width="300" trigger="click">
              <el-row v-for="(item,index) in TemplateMenu" @mouseenter.native="selectIndex=index"
                class="tagrow" :style="{'border-bottom': TemplateMenu.length==(index+1)?'':'1px solid #eaecf2'}" style="padding: 8px 10px 8px 10px;font-size: 16px;font-weight: unset;"
                :key="index">
                <el-col :span="selectIndex==index?10:16" @click.native="menuClick(item)">{{item.NAME}}</el-col>
                <el-col :span="6" style="text-align: right;" v-if="selectIndex==index">
                  <el-link :type="item.ISDEFAULT?'primary':'warning'" @click="setDefault(item);">{{item.ISDEFAULT?"取消默认":"设为默认"}}</el-link>
                </el-col>
                <el-col :span="8" style="text-align: right;">
                  <el-switch @change="ShowHide(item)" :disabled="item.NAME=='首页'" v-model="item.VISIBLE">
                  </el-switch>
                </el-col>
              </el-row>
              <div slot="reference" class="sysTabbarItem" v-ripple style="width:45px;" :class="{ sysTabSelected: false}">
                <div class="iconRight">
                  <i style="margin-left: 0px;" :class="iconType"></i>
                </div>
              </div>
            </el-popover>

            <!--<div
              class="sysTabbarItem"
              :class="{ sysTabSelected: true}"
            ><i class="iconfont icon-zhuye"></i>首页</div>
             <div
              class="sysTabbarItem"
              :class="{ sysTabSelected: false}"
            >团队任务</div>-->
          </div>
        </div>
      </el-col>

      <el-col :span="isHearderMenu?6:12" class="lineh">
        <CommonNotice></CommonNotice>
        <el-divider direction="vertical"></el-divider>
        <collect></collect>
        <el-divider direction="vertical"></el-divider>
        <el-tooltip content="草稿箱" placement="top" effect="light">
          <i class="iconfont icon-caogaoxiang-" @click="draft()" style="cursor: pointer;"></i>
        </el-tooltip>
        <el-divider direction="vertical"></el-divider>
        <el-popover placement="bottom" trigger="manual" width="140" v-model="loginVisible" class="poplogin">
          <span class="acclogin" slot="reference">
            <span @click="acclogIn">
              <span class="peopleImg">
                <el-image style="width: 32px; height: 32px" :src="peopleUrl" fit="contain"></el-image>
              </span>
              <span class="people">{{realName}}</span>
            </span>
          </span>

          <!-- 登录模块 -->
          <login-modu ref="loginModu" :loginVisible="loginVisible" @closeDialog="closeDialog" @closelogm="closelogm"
            class="loginM"></login-modu>
        </el-popover>

      </el-col>
    </el-row>

  </div>
</template>

<script>
  import configApi from "@/api/modules/basicData/config";
  import collect from '../taskFolderView/collect'
  import {
    SetDefaultTemplate,
  } from "@/api/modules/basicData/task";
  import CommonNotice from "./Notice/index.vue";
  import loginModu from "./login/loginModu.vue";
  import {
    mapState
  } from "vuex";
  import {
    UpdateTemplateUserSetting
  } from "@/api/modules/basicData/task";
  import {
    getToken
  } from '../../../util/auth'
  const cookieUser = getToken()
  export default {
    components: {
      CommonNotice,
      loginModu,
      collect
    },
    data() {
      return {
        menuName: this.$route.query.menuname,
        iconBig: "font-size: 22px",
        downListState: false,
        loginVisible: false, //登录框默认不显示
        selectIndex: -1,
        maxCount: 7,
        imgUrl: require("@/assets/0/logo.jpg"),
        peopleUrl: require("@/assets/0/people.png"),
        menuId: '1408',
        title: "安医附院综合服务平台",
        Config: {},
        searchParams: {
          TaskStyle: 1,
          TypeIndex: -1,
          TaskInstance: "",
          ExcuteState: "",
          TaskName: "",
          CreateTime2: "",
          CreateTime1: "",
          CreateUser: {},
          ExcuteUser: {},
          TaskType: [],
          CurrentUserId: cookieUser.userId,
          CreateUserIds: cookieUser.userId,
          state: [],
          TaskRightId: "",
          TaskDegree: []
        },
      };
    },
    props: {
      isHearderMenu: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        realName: state => state.task.realName,
        userId: state => state.task.userId,
        TemplateMenu: state => state.task.TemplateMenu,
      }),
      iconType() {
        return this.downListState ? "el-icon-arrow-down" : "el-icon-arrow-right"
      },
      TemplateMenuShow() {
        return this.$store.state.task.TemplateMenu.filter(item => item.VISIBLE == true);
      },
      TemplateMenuSetting() {
        return this.$store.state.task.TemplateMenu.filter(item => item.NAME != '首页');
      }
    },
    methods: {
      closelogm(val) {
        console.log(val);

        this.loginVisible = val;
      },
      closeDialog(val) {
        this.loginVisible = val;
      },
      acclogIn() {
        // this.loginVisible=true;
        this.loginVisible = !this.loginVisible;
        console.log("登录模块", this.loginVisible);

      },
      enter(data) {
        console.log('移入', data.NAME);
        data.isShow = true
      },
      leave(data) {
        console.log('移出', data.NAME);
        data.isShow = false;
      },
      draft() {
        this.menuId = null;
        this.$store.commit('setTaskStyle', {
          TaskStyle: 1
        });
        this.searchParams.TaskStyle = 1;
        this.$store.dispatch("changeTaskParas", this.searchParams);
        this.$emit('getComponent', {
          MEMO: 'taskTemplate',
          TaskType: ''
        });
      },
      //收藏
      collect() {
        //  this.
      },
      menuClick(data) {
        if (data) {
          this.menuId = data.ID;
          this.$emit('getComponent', data);
        }
      },
      ShowHide(row) {
        console.log('ShowHide', row);
        if (this.TemplateMenuShow.length > this.maxCount) {
          this.$message.info('最多显示' + this.maxCount + '个')
          this.TemplateMenuShow.forEach(item => {
            if (row.ID === item.ID) {
              item.VISIBLE = false;
            }
          });
        } else {
          UpdateTemplateUserSetting(row.ID, this.userId, row.VISIBLE).then(res => {

          })
        }
      },
      setDefault(row) {
        SetDefaultTemplate(row.ID, this.userId, row.CATEGORY, 1, row.ISDEFAULT).then(res => {
          if (res == 1) {
            this.TemplateMenu.forEach(item => {
              if (row.ID == item.ID && !row.ISDEFAULT)
                item.ISDEFAULT = true;
              else
                item.ISDEFAULT = false;
            })
            this.$message({
              type: "success",
              message: "设置成功!"
            });
          }
        });
      },
    },
    mounted() {
      this.$nextTick(() => {

        setTimeout(() => {
          configApi
            .GetSite(0)
            .then(result => {
              console.log(result);
              let item = JSON.parse(result);
              item.logo = this.Backstage_ROOT + item.logo;
              this.Config = item;
            })
            .catch(err => {
              this.$message.error(err);
            });
        }, 1000);
        setTimeout(() => {
          if(this.menuName){
            let defaultInfo = this.TemplateMenu.find(item => item.NAME == this.menuName)
            if (defaultInfo) this.menuClick(defaultInfo)
            else this.menuClick(this.TemplateMenu[0])
          }else{
            let defaultInfo = this.TemplateMenu.find(item => item.ISDEFAULT == true)
            console.log('this.TemplateMenuShow', defaultInfo);
            if (defaultInfo) this.menuClick(defaultInfo)
            else this.menuClick(this.TemplateMenu[0])
          }
        }, 1500);
      });
    }
  };
</script>

<style lang="scss" scoped>
  .iconRight {
    height: 27px;
    width: 22px;
    // background-color: #57C2FB;
    margin-top: 10px;
    line-height: 27px;
    border-radius: 4px;
    text-align: center;
  }

  .iconCircle {
    height: 39px;
    width: 39px;
    border-radius: 50%;
    margin-top: 4px;
    line-height: 39px;
  }

  .iconCircle:hover {
    // background-color: #1590D1;
  }

  .poplogin {
    padding: 0px !important;
    height: 200px;
  }

  .acclogin {
    cursor: pointer;
  }

  .loginM {
    width: 100%;
    height: 105px;
  }

  .title {
    margin-left: 5px;
    margin-top: 5px;
    font-size: 24px;
    letter-spacing: 0.9px;
    float: left;
    color: white;
  }

  .distribution {
    background-color: rgb(25, 172, 249);
    color: #ffffff;
    padding: 0 20px;
  }

  .people {
    font-size: 18px;
    letter-spacing: 0.6px;
  }

  .peopleImg {
    background-color: rgb(25, 172, 249);
  }

  .lineh {
    text-align: right;
    margin-top: -4px;
    background-color: rgb(25, 172, 249);
  }
</style>

<style scoped>
  .distribution>>>.el-divider--vertical {
    margin-bottom: 2px;
  }

  .peopleImg>>>.el-image {
    top: 10px;
  }

  .lineh>>>.el-button--primary {
    background-color: rgb(25, 172, 249);
    border-color: rgb(25, 172, 249);
  }

  .lineh>>>.el-button--mini {
    font-size: 16px;
  }
</style>
<style lang="less" scoped>
  .el-popover {
    padding: 0px !important;
    min-width: 100px !important;
  }

  // .sysTabbar:hover {
  //   .iconRight {
  //     opacity: 1;
  //     transition: all 0.5s;
  //   }
  // }

  .sysTabbar {
    width: 100%;
    height: 47px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .sysTabbarList {
      display: flex;

      .sysTabbarItem {
        cursor: pointer;
        width: 65px;
        text-align: center;
        box-sizing: border-box;
        position: relative;
        padding-left: 13px;
        margin-left: 2px;
        line-height: 44px;
        color: #ffffff;
        overflow: hidden;
        .angle{
          height: 15px;
          width: 15px;
          background-color: #FFFFFF;
          position: absolute;
          left: 25px;
          border-radius: 1px;
          transform:rotate(45deg);
          -ms-transform:rotate(45deg); 	/* IE 9 */
          -moz-transform:rotate(45deg); 	/* Firefox */
          -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
          -o-transform:rotate(45deg); 	/* Opera */
        }

        i {
          margin-left: 4px;
        }

        .iconfont {
          margin-right: 3px;
        }
      }

      .sysTabSelected {

      }
    }

    .sysTabbarEdit {
      cursor: pointer;
      width: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
